<template>
  <v-container grid-list-md fluid class="pt-0">

    <v-card class="pa-2 card-r">
      <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 text-white">
        <!--<router-link to="/"><v-icon class="text-white left pr-3">keyboard_arrow_left</v-icon></router-link>-->
        <div class="text-xs-left f-20">Settings</div>
      </v-toolbar>
    </v-card>

    <v-card class="pa-2 mt-3 card-r grey lighten-4">
      <v-layout row wrap class="ma-2">
        <v-flex lg12 class="pa-0">
          <template>
            <v-combobox
              v-model="chips"
              :items="getall_loc"
              item
              label="Add class locations for teacher"
              chips
              prepend-icon="filter_list"
              solo
              multiple>
              <template v-slot:selection="data">
                <v-chip
                  close
                  @input="remove(data.item)">
                  <strong>{{ data.item }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-combobox>
          </template>
        </v-flex>
        <v-flex lg12 class="pa-0">
          <v-btn class="right card-r primary text-capitalize ma-0" @click="createpickuplocation()">Add</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    

    <v-card class="pa-2 mt-3 card-r grey lighten-4">
      <v-layout row wrap class="ma-2">
        <settings-lists/>
        <v-flex lg12 class="pa-0">
            <v-card class="pa-3 card-r white">
              <div class="f-15 text-xs-left w-100 textColor font-weight-bold pl-1">Roles for Admin</div>
              <v-checkbox outline class="pa-0 ma-0"
                          v-model="userRole"
                          :disabled=userRole
                          :items="cancel_time_"
                          attach
                          chips
                          label= "Admin can be teacher"
                          @change="changeRole()"
                          v-bind:messages="roleMessage"
              ></v-checkbox>
            </v-card>
        </v-flex>
      </v-layout>
      <!-- <v-flex xs12 class="pt-0">
        <div class="text-xs-right w-100">
          <v-btn class="card-r grey text-white" dark to="/">Don't Save</v-btn>
          <v-btn color="primary darken-2" class="card-r" dark @click="updateCancelTime" >SAVE</v-btn>
        </div>
      </v-flex> -->
    </v-card>
  </v-container>
</template>

<script>
  /* eslint-disable */
  import api from "@/utils/backend-api"
  import SettingsLists from "../test/SettingsLists";

  export default {
    components: {SettingsLists},
    props:["id"],
    name: "EditCustomer",
    data: () => ({
      trip: {
        location: null,
      },
      pickup_locations: '',
      alllocations:'',
      chips: [],
      locationstatus:false,
      ClubView: null,
      passwordShow: false,
      EditClub: false,
      date: null,
      birthday: false,
      Membershipdata:null,
      Package_type: [],
      studentExam:false,
      gender_:['male','female'],
      schoolName:"",
      name: "",
      phone:"",
      club_number: "",
      gender: "",
      state: "",
      city: "",
      discription: "",
      address:"",
      adminpassword: "",
      adminemail:"",
      zip:"",
      cancellation_time_period:null,
      errormessage:"",
      roleMessage:"",
      examMessage:"",
      cancel_time_:[],
      commission:"",
      package_: [],
      memberShipID:[],
      passwordRule: [
        v => !!v || "Password is required",
        v => v.length >= 8 || "Password must be more than 8 characters"
      ],
      phoneRule: [
        v => !!v || "Phone Number is required",
        v => v.length <= 8 || "Minimum 8 Digits number"
      ],
      userRole:'',
      alertType:'',
      alertMessage:''

    }),
    created(){
      this.getalllocations()
      let roles=Store.state.user.roles
      if(roles.includes('teacher')){
        this.userRole=true
      }
      let cancelTime
      for(let x=1;x<=5;x++){
        cancelTime = x+' '+this.$t('settings_page.day_text')
        this.cancel_time_.push(cancelTime)
      }
    },
    methods: {
      getalllocations(){
        let self=this
        api.postData('admin/viewLocations')
          .then((res)=>{
            // this.chips=res.data
            var data= res.data
            Store.dispatch('setLocations',data)
            self.chips= res.data.locations
            console.log(this.getall_loc)
          }).catch(err=>{
            console.log(err)
        })
      },
      createpickuplocation(){
        var data={
          locations:this.chips
        }
        api.postData('admin/createLocations',data)
          .then((res)=>{
            console.log(res.data)
            // this.pickup_locations = ''
            // this.locationstatus =true
          })
      },
      remove (item) {
        this.chips.splice(this.chips.indexOf(item), 1)
        this.chips = [...this.chips]
      },
      changeRole(){
        let self=this
        // this.loading=true
        self.roleMessage=""
        api.postData('admin/addTeacherRole')
          .then(res=>{
            // self.loading=false
            if(res.status==201){
              self.userRole=true
              // self.alertType="success"
              self.roleMessage="<span style='color: #1d84d5'>Successfully set the teacher role<span>"
            }else if(res.status==200){
              self.userRole=true
              self.roleMessage="<span style='color: #1d84d5'>Role already set<span>";
            }
            setTimeout(() => {
              this.roleMessage=''
            }, 3500);
          }).catch(err=>{
          // self.loading=false
          self.userRole=false
          // self.alertType="error"
          // self.alertMessage="failed to set the teacher role"
          self.roleMessage="<span style='color: #1d84d5'>failed to set the teacher role<span>";
        })
      },
      changeExam(){
        let self=this
        // this.loading=true
        self.examMessage=""
        var examData={
          'test_package_id':this.TestPackageid,
          'admin_test_package_price':this.PackagePrice,
          'status':this.status,
        }
        var formData=new FormData()
        formData.append("test_package_id",22)
        formData.append("admin_test_package_price",500)
        formData.append("status","active")
        api.postData('admin/updateBookedTestPackage', formData)
          .then(res=>{
            // self.loading=false
            if(res.status==201){
              self.studentExam=true
              // self.alertType="success"
              self.examMessage="<span style='color: #1d84d5'>Successfully enabled/disabled exam<span>"
            }else if(res.status==200){
              self.studentExam=true
              self.examMessage="<span style='color: #1d84d5'>Role already set<span>";
            }
            setTimeout(() => {
              this.examMessage=''
            }, 3500);
          }).catch(err=>{
          // self.loading=false
          self.studentExam=false
          // self.alertType="error"
          // self.alertMessage="failed to set the teacher role"
          self.examMessage="<span style='color: #1d84d5'>Failed to enable <span>";
        })
      },
      pushToCustomer(){
        if (this.$store.state.ViweClubDetail==null){
          this.$router.push("../customers")
          this.$notify({
            group: "error",
            type: "error",
            text: "Error"
          });
        }
      },
      updateCancelTime() {
        if(this.cancellation_time_period !== null) {
          Store.dispatch('updateCancelTime', parseInt(this.cancellation_time_period)).then(request=>{
            this.cancellation_time_period = null;
            this.errormessage = "<span style='color: green'>Time has been updated successfully & Student can book class again within this time<span>";
          });
        } else {
          this.errormessage = "<span style='color: red'>Please select class cancellation time for student class<span>";
        }
        setTimeout(() => {
          this.errormessage=''
        }, 3500);
      },
      onSignup() {
        var admin_id = this.$store.state.ViweClubDetail.admin_id
        var club_id = this.$store.state.ViweClubDetail.id
        var adminData={
          name: this.name,
          email: this.adminemail,
          phone: this.phone,
          dob: this.date,
          address: this.address,
          city: this.city,
          state: this.state,
          zip: this.zip,
          gender: this.gender.toLowerCase(),
        }
        this.getMembershipID()
        this.$store.dispatch('adminEdit',{adminData,admin_id})
          .then(response=>{
              var ClubData = {
                name:this.schoolName,
                admin_id:admin_id,
                cancellation_time_period:this.cancel_time,
                commission:this.commission,
                membership_id:this.memberShipID
              }
              this.$store.dispatch('clubEdit',{ClubData,club_id} )
                .then(clubRes=>{
                    this.$notify({
                      group: "success",
                      type: "success",
                      text: "update Success"
                    });
                    this.$router.push("../customers")
                  },
                  error=>{
                    this.$notify({
                      group: "error",
                      type: "error",
                      text:error.message,
                    });
                  })
            },
            error=>{
              this.$notify({

                group: "error",
                type: "error",
                text:error.message,
              });

            })
      },
      getpackage (){
        this.$store.dispatch('getPackage').then(res=>{
          this.Membershipdata = res.data
          for(let key in this.Membershipdata){
            this.package_.push(this.Membershipdata[key].name )
          }
        },error=>{

        })
      },
      getMembershipID(){
        for (let i = 0; i < this.Package_type.length; i++) {
          for (let a = 0; a < this.Membershipdata.length; a++) {
            if (this.Package_type[i]==this.Membershipdata[a].name){
              this.memberShipID.push(this.Membershipdata[a].id)
            }
          }
        }
      },
      getPackageName(data){
        var packagename=[]
        for (let i = 0; i < data.length; i++) {
          for(let key in this.Membershipdata){

            if (data[i]== this.Membershipdata[key].id){
              packagename.push(this.Membershipdata[key].name)
            }
          }
        }
        return packagename
      },
    },
    computed:{
      getall_loc() {
        return Store.state.pickuplocations.locations
      }
    },
    watch: {
      // locationstatus: function () {
      //   if(this.locationstatus === true){
      //     this.getalllocations()
      //   }
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Settings.vue